import React from "react";
import classnames from "classnames";

export const MainButton = ({ iconResting, iconActive, className, label, style, href, onClick }) => {
  var iconResting = classnames("mfb-component__main-icon--resting", iconResting);
  var iconActive = classnames("mfb-component__main-icon--active", iconActive);
  var mainClass = classnames("mfb-component__button--main", className);
  if (label) {
    return (
      <a href={href} style={style} className={mainClass} onClick={onClick} data-mfb-label={label}>
        <i className={iconResting}></i>
        <i className={iconActive}></i>
      </a>
    );
  } else {
    return (
      <a href={href} style={style} className={mainClass} onClick={onClick}>
        <i className={iconResting}></i>
        <i className={iconActive}></i>
      </a>
    );
  }
};

MainButton.defaultProps = {
  href: "#",
  onClick: function () {},
  iconResting: "",
  iconActive: "",
  label: null,
};
